module.exports = __webpack_public_path__ + "img/9.8f1d07c.png";